import React, { useState, useEffect } from 'react';
import './Pagamento.css';
import PagamentoPix from './PagamentoPix';
import PagamentoCartao from './PagamentoCartao';
import HistoricoPagamento from './HistoricoPagamento';

const PagamentoPage = () => {
    const [activeTab, setActiveTab] = useState('pix');
    const [alert, setAlert] = useState({ show: false, message: '', type: 'info' });
    const [loading, setLoading] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        // Verificar se o usuário está autenticado
        const token = sessionStorage.getItem('usuarioToken');
        const usuarioId = localStorage.getItem('usuarioId') || sessionStorage.getItem('usuarioId');
        
        if (token && usuarioId) {
            setIsAuthenticated(true);
            showAlert('ℹ️ Bem-vindo! Selecione seu método de pagamento', 'info');
        } else {
            showAlert('⚠️ Para processar pagamentos, é recomendável estar autenticado', 'info');
        }
    }, []);

    const showAlert = (message, type = 'info') => {
        setAlert({ show: true, message, type });
        
        if (type !== 'error') {
            setTimeout(() => {
                setAlert({ show: false, message: '', type: 'info' });
            }, 5000);
        }
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    return (
        <div className="payment-page">
            <div className="payment-container">
                <div className="payment-header">
                    <h1>💳 Sistema de Pagamento</h1>
                    <p>Assinatura Mensal/Anual - Escolha seu método de pagamento</p>
                </div>

                <div className="payment-content">
                    {/* Alerta de mensagens */}
                    {alert.show && (
                        <div className={`alert ${alert.type}`}>
                            {alert.message}
                        </div>
                    )}

                    {/* Informações de Preço */}
                    <div className="price-info">
                        <p>Valores:</p>
                        <div className="price-value">
                            💰 R$ 350 / mês ou R$ 3.850,00 / ano
                        </div>
                        <p>Pagamento único por período selecionado</p>
                    </div>

                    {/* Tabs */}
                    <div className="tabs">
                        <button 
                            className={`tab-button ${activeTab === 'pix' ? 'active' : ''}`}
                            onClick={() => handleTabChange('pix')}
                        >
                            📱 PIX
                        </button>
                        <button 
                            className={`tab-button ${activeTab === 'cartao' ? 'active' : ''}`}
                            onClick={() => handleTabChange('cartao')}
                        >
                            💳 Cartão de Crédito
                        </button>
                        {isAuthenticated && (
                            <button 
                                className={`tab-button ${activeTab === 'historico' ? 'active' : ''}`}
                                onClick={() => handleTabChange('historico')}
                            >
                                📋 Histórico
                            </button>
                        )}
                    </div>

                    {/* Conteúdo das Tabs */}
                    <div className="tabs-content">
                        {activeTab === 'pix' && (
                            <PagamentoPix 
                                showAlert={showAlert}
                                setLoading={setLoading}
                            />
                        )}
                        
                        {activeTab === 'cartao' && (
                            <PagamentoCartao 
                                showAlert={showAlert}
                                setLoading={setLoading}
                            />
                        )}
                        
                        {activeTab === 'historico' && isAuthenticated && (
                            <HistoricoPagamento />
                        )}
                    </div>

                    {/* Loading */}
                    {loading && (
                        <div className="loading">
                            <div className="spinner"></div>
                            <p>Processando pagamento...</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PagamentoPage;
